

module.exports = {
    handleError(err) {
        // console.error(err);
        const responseData = err.response?.data;
        const subscriptionStatus = responseData?.subscription_status;
        // console.log(err)
        switch (err?.status) {
            case 401:
                // console.log("Unauthorized");
                localStorage.removeItem("user_token");
                // console.log(window.location)
                if (window.location.href.includes('login')) {
                  if (responseData?.message) {
                    return responseData?.message
                  }
                  return 'Invalid Login Credentials'
                } else {
                  window.location.href = "/login";
                }
                // window.location.href = "/login";
                break;
            case 402:
                if (subscriptionStatus === 'County_Expired') {
                    window.location.href = '/CountyExpired'
                  } else if (subscriptionStatus === 'No_Stripe_ID' || subscriptionStatus === 'No_Subscription' || subscriptionStatus === 'Removed_From_County') {
                    window.location.href = '/CreateSubscription'
                  } else if (subscriptionStatus === 'Expired') {
                    // console.log('Redirecting to reactivateSubscription'); // Additional log to ensure this branch is reached
                    window.location.href = '/reactivateSubscription' 
                  } else if (subscriptionStatus === 'Pending Invitation Status') {
                    window.location.href = '/invitation/pending' 
                  } else {
                    window.location.href = "/error?code=402";
                    // console.log('Else Error 402'); // Added this log for clarity=
                  }
                  break;
            case 403:
                // console.log("Forbidden");
                localStorage.removeItem("user_token");
                window.location.href = "/login";
                break;
            case 404:
                // console.log("Not Found");
                window.location.href = "/error?code=404";
                break;
            case 409: 
                return 'Too Late'
                break;
            case 410:   
                window.location.href = "/error?code=410";
                break;  
            case 429:   
                window.location.href = "/error?code=429";
                // console.log("Too many requests");
                return "Too many requests";
                break;  
            case 500:
                // console.log("Internal Server Error");
                window.location.href = "/error?code=500";
                break;
            default:
                // window.location.href = "/error?code=500";
                // console.log("Error");
                break;
        }
    },
}

